import FormData from 'form-data';
export default FormData;



//////////////////
// WEBPACK FOOTER
// ./node_modules/axios/lib/env/classes/FormData.js
// module id = WnJR
// module chunks = 20